module.exports = __webpack_public_path__ + "img/advantageGreen.4cb1e21a.jpg";